import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppState, Openable } from '../stores/appStateStore';
import { action } from 'mobx';
import { AppProps } from './App';

interface LoadingListItemProps extends AppProps {
    name: string;
    numberOfEmails: number;
    eject?: () => void;
}

// Instead of controlling state directly we inherit the relevant information and controls from our parent.
const LoadingListItem = observer((props: LoadingListItemProps) => {
    const {name, numberOfEmails, eject} = props;
    return (
        <div className="folder prevent-select flex-mother">
            <div className={'ml-0em p-3px'} />
            <div className="ml-1em h-navbarButton-half"/>
            <div>
                <div className="flex-mother-col fill">
                    <div className="flex-1" />
                    <i className='file-icon'/>
                    <div className="flex-1" />
                </div>
            </div>
            <div className="flex-1">
                <div className="flex-mother-col fill pl-5px">
                    <div className="flex-1" />
                    <div>{name}</div>
                    <div className="flex-1" />
                </div>
            </div>
            <div className="flex-mother-col">
                <div className="flex-1" />
                <div>{numberOfEmails}</div>
                <div className="flex-1" />
            </div>
            {eject !== undefined? <button className="navbarButton-half" title="Unload file" onClick={action(e => {e.stopPropagation(); eject();})}><i className="eject-icon"/></button>:''}
        </div>
    );
});

export default LoadingListItem;